import type { RegistrationStep } from '../../../components/RegistrationStepper/RegistrationStepper';

/**
 * Self-registration has no email OTP step (removed at the client's request): Azure B2C verifies
 * the email with its own code when the investor sets a password.
 */
export const SELF_STEPS: RegistrationStep[] = [
  { num: 1, label: 'Interest', icon: 'bi-globe2' },
  { num: 2, label: 'Consent', icon: 'bi-shield-check' },
  { num: 3, label: 'Email', icon: 'bi-envelope' },
  { num: 4, label: 'Details', icon: 'bi-person-badge' }
];
